export default __webpack_public_path__ + "i18n/translation-it.3fa7d9ef.json";